<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="设置鉴权规则"
      width="500px"
      height="300px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="setting-item">
          <span>鉴权方式：</span>
          <el-radio class="title-radio" :label="0" v-model="authMethod">账号鉴权</el-radio>
        </div>
        <div class="setting-item">
          <span>阅读期限：</span>
          <el-radio class="title-radio" :label="true" v-model="isPermanent">永久</el-radio>
          <el-radio class="title-radio no_text" :label="false" v-model="isPermanent"></el-radio>
          <el-input v-model="dateLimit" type="number" :disabled="isPermanent" size="mini"></el-input>
          <span>个月</span>
        </div>
        <div class="setting-item">
          <span>试读范围：</span>
          <el-radio class="title-radio no_text"></el-radio>
          <span>前</span><el-input v-model="pageLimit" type="number" size="mini"></el-input> <span>页</span>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="saveThen()">保存</div>
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import chargeApi from '@api/chargeManager'

export default {
  name: 'AuthSetting',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      id: '',
      authMethod: '',
      dateLimit: null,
      pageLimit: null,
      trialOption: 0,
      isIndividual: 0,
      isPermanent: true
    }
  },
  props: {
    workObj: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initSetting()
      }
    }
  },
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    saveThen() {
      if ((this.pageLimit === null || this.pageLimit < 0 || this.pageLimit % 1 !== 0 || this.pageLimit === '') && this.trialOption === 0) {
        this.$message({
          message: '请设置试读范围，输入0-9999的整数',
          type: 'error'
        })
        return
      }
      let period = this.isPermanent ? 0 : this.dateLimit
      if (period === null || (!this.isPermanent && period <= 0) || period % 1 !== 0 || period > 99) {
        this.$message({
          message: '请设置阅读期限,输入1-99的整数',
          type: 'error'
        })
        return
      }
      let param = {
        id: this.id,
        authMethod: this.authMethod,
        period: period,
        chargePage: this.pageLimit,
        trialPercent: this.articleLimit,
        trialOption: this.trialOption
      }
      chargeApi.authSetting(param).then((res) => {
        if (res.data && res.data.status === 0) {
          this.dialogVisible = false
          this.$emit('saveSuccess')
        } else {
          this.$message({
            message: res.data.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    initSetting() {
      this.id = this.workObj.id
      this.authMethod = this.workObj.authMethod
      this.dateLimit = this.workObj.period
      this.pageLimit = this.workObj.chargePage
      this.trialOption = this.workObj.trialOption
      if (this.dateLimit === 0 || this.dateLimit === null) {
        this.isPermanent = true
        this.dateLimit = null
      } else {
        this.isPermanent = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-container {
  .setting-item {
    margin-bottom: 10px;
    font-size: 12px;
    .el-input {
      display: inline-block;
      width: 40px;
      margin-right: 10px;
    }
    span {
      margin-right: 10px;
      font-size: 14px;
    }
    &.limit-item {
      display: flex;
      & > :first-child {
        word-break: keep-all;
        line-height: 26px;
      }
      .el-radio {
        margin-bottom: 10px;
      }
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.setting-item {
  .el-input {
    input.el-input__inner {
      height: 26px;
      line-height: 26px;
      padding-right: 0;
      padding-left: 0;
      text-align: center;
    }
  }
  .no_text {
    .el-radio__label {
      display: none;
    }
    margin-right: 5px;
  }
}
</style>
